const backendUri = process.env.REACT_APP_BACKEND_URI;
export const BASE_URL =
  typeof backendUri === 'string' && backendUri.length > 0
    ? backendUri.replace(/\/$/, '')
    : '';

if (!BASE_URL && typeof window !== 'undefined') {
  // Misconfigured staging builds previously baked ENV as objects / undefined and
  // produced relative calls like curator-dev.songplace.io/undefined/auth0/...
  console.error('REACT_APP_BACKEND_URI is not configured');
}

const LOCAL_SUBMISSION_BACKEND_URL = 'http://localhost:5001';
const DEV_SUBMISSION_BACKEND_URL = 'https://submission-v2-api.songplace.io';
const DEFAULT_SUBMISSION_BACKEND_URL = 'https://api.songplace.io';

export const getSubmissionBackendUrl = () => {
  const override = process.env.REACT_APP_SUBMISSION_BACKEND_URI;
  if (override) {
    return override.replace(/\/$/, '');
  }

  if (typeof window === 'undefined') {
    return DEFAULT_SUBMISSION_BACKEND_URL;
  }

  const currentUrl = window.location.href.toLowerCase();

  if (currentUrl.includes('localhost')) {
    return LOCAL_SUBMISSION_BACKEND_URL;
  }

  if (currentUrl.includes('curator-dev')) {
    return DEV_SUBMISSION_BACKEND_URL;
  }

  return DEFAULT_SUBMISSION_BACKEND_URL;
};
